import { GetBy } from '../_app/cuchillo/core/Element';
import _Header from '../_app/cuchillo/layout/Header';
import gsap, { Power2, Power3 } from "gsap";
import Flappy from '../components/Flappy';
import SelectScreen from './SelectScreen';

export default class EndScreen {
  static current = 0;
  static total = 0;
  static container = GetBy.id("End");
  static buttonPlay = GetBy.selector("[data-play]", this.container)[0];
  static buttonSelect = GetBy.selector("[data-select]", this.container)[0];
  static tips = [...GetBy.selector("[data-tip]", this.container)];

  static set score(value) {
    this._score = value;
    this.domScore.innerHTML = value;
    this.domScoreA.innerHTML = Math.floor(value * 0.6);
    this.domScoreB.innerHTML = Math.floor(value * 0.89);
    this.domScoreC.innerHTML = Math.floor(value * 0.22);
  }

  static setup() {
    this.container.style.display = "none";
    gsap.set(this.container,{opacity:0});

    this.total = this.tips.length;

    this.domScore = GetBy.selector("[data-points-main]", this.container)[0];
    this.domScoreA = GetBy.selector("[data-points-a]", this.container)[0];
    this.domScoreB = GetBy.selector("[data-points-b]", this.container)[0];
    this.domScoreC = GetBy.selector("[data-points-c]", this.container)[0];

    this.buttonPlay.addEventListener('click', () => { this.hide();  });
    this.buttonSelect.addEventListener('click', () => { SelectScreen.show(); });
  }

  static showTip() {
    for(let i = 0; i< this.total; i++) {
      if(i === this.current) this.tips[i].style.display = "block";
      else this.tips[i].style.display = "none";
    }

    this.current = this.current + 1 == this.total? 0 : this.current + 1;
  }

  static show() {
    this.score = Flappy.score;
    this.showTip();
    this.container.style.display = "flex";
    gsap.to(this.container,{opacity:1, ease:Power2.easeIn, duration:.4});
  }

  static hide() {
    gsap.to(this.container,{opacity:0, ease:Power2.easeOut, duration:.1, onComplete:()=> {
      this.afterHide();
      Flappy.start();
    }});
  }

  static afterHide() {
    this.container.style.display = "none";
  }
}


